import type { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { WarningAltFilled } from '@mint-lib/icons';
import {
  ConfirmationDialog,
  ConfirmationDialogAction,
  ConfirmationDialogCancel,
  ConfirmationDialogContent,
  ConfirmationDialogDescription,
  ConfirmationDialogFooter,
  ConfirmationDialogHeader,
  ConfirmationDialogOverlay,
  ConfirmationDialogPortal,
  ConfirmationDialogRoot,
  ConfirmationDialogTitle,
} from '@mint-lib/tw-components';

import { APPROVAl_FLOW_FORM_ID } from '../../constants/singleFlow.js';

type Props = {
  open: boolean;
  onClose: () => void;
};

const ConfirmChangeInNewProcessModal: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation('@myn/approval_v2');

  const handleOpenChange = (open: boolean) => {
    if (open) {
      return;
    }
    onClose();
  };

  return (
    <ConfirmationDialog open={open} onOpenChange={handleOpenChange}>
      <ConfirmationDialogPortal>
        <ConfirmationDialogOverlay onClick={onClose} />
        <ConfirmationDialogRoot>
          <ConfirmationDialogHeader onClose={onClose}>
            <WarningAltFilled className="size-4 fill-warning-main" />
            <ConfirmationDialogTitle>
              {t('Update approval flow?')}
            </ConfirmationDialogTitle>
          </ConfirmationDialogHeader>
          <ConfirmationDialogContent>
            <ConfirmationDialogDescription>
              <span>
                {t(
                  'These changes will only take effect on new approval processes initiated after saving.',
                )}
              </span>{' '}
              <span>
                {t('Changes will never affect processes already in progress.')}
              </span>
            </ConfirmationDialogDescription>
          </ConfirmationDialogContent>
          <ConfirmationDialogFooter>
            <ConfirmationDialogCancel
              data-dd-action-name="Close the modal"
              type="button"
              onClick={onClose}
            />
            <ConfirmationDialogAction
              data-dd-action-name="Submit action"
              type="submit"
              color="warning"
              form={APPROVAl_FLOW_FORM_ID}
            >
              {t('Yes, update')}
            </ConfirmationDialogAction>
          </ConfirmationDialogFooter>
        </ConfirmationDialogRoot>
      </ConfirmationDialogPortal>
    </ConfirmationDialog>
  );
};

export default ConfirmChangeInNewProcessModal;
